import { ErrorBoundary } from '@/services/sentry';
import useViewPort from '@/utils/useViewport';

import { DesktopFilters } from './DesktopFilters/DesktopFilters';
import { MobileFilters } from './MobileFilters/MobileFilters';

export const Filters = () => {
  const { isMobile, isTablet } = useViewPort();

  const isMobileOrTablet = isMobile || isTablet;

  return <ErrorBoundary>{isMobileOrTablet ? <MobileFilters /> : <DesktopFilters />}</ErrorBoundary>;
};
